import React, { useEffect } from 'react';
import zonLogo from '../footer/zon-logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (
        <div>
            <footer>
                <section className="wed-hom-footer">
                    <div className="container">

                        <div className="row wed-foot-Link mx-auto justify-content-center">
                            <div className="col-lg-4 foot-tc-mar-t-o justify-content-center">
                                <h4 className='text-white-50'>Departments</h4>
                                <ul className='p-0'>
                                    <li>
                                        <Link to="/dept/cse" >CSE</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/cse-ds/" >CSD</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/ai-ml/" >CSM</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/ece/"  >ECE</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/ece/"  >ECE - VLSI design & Technology</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/it/"  >IT</Link>
                                    </li>
                                    
                                    <li>
                                        <Link to="/dept/mba/"  >MBA</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/mca/"  >MCA</Link>
                                    </li>
                                    <li>
                                        <Link to="/dept/m-tech/" >M.Tech Department</Link>
                                    </li>

                                    <li>
                                        <Link to="/dept/s-and-h/ ">S&amp;H Department</Link>
                                    </li>

                                    <li>
                                        <Link to="/dept/library/">Library Department</Link>
                                    </li>

                                    <li>
                                        <Link to="/training-and-placements/">Training &amp; Placement Cell</Link>
                                    </li>

                                </ul>
                            </div>
                            <div className="col-lg-4">
                                <h4 className='pt-4 pt-md-0 pb-md-0 text-white-50 p-0'>Quick Links</h4>
                                <ul className='p-0'>
                                    <li><Link to="/autonomous-syllabus">Syllabus</Link></li>
                                    <li><Link to="/time-tables/">Time Tables</Link></li>
                                    <li><Link to="/notifications/">Notifications</Link></li>
                                    <li><Link to="/extension-activities">Extension Activities</Link></li>
                                    <li><Link to="/copyright-policy">Copyright Policy</Link></li>
                                    <li><Link to="/intellectual-property-rights">Intellectual Property Rights</Link></li>
                                    <li>
                                        <Link to="/contact-us/">Contact us</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-4">
                                <h4 className='pt-4 pt-md-0 pb-md-0 text-white-50' >Get In Touch</h4>
                                {/* <ul>

                                    <li>
                                        <Link  to="/contact-us/">Contact us</Link>
                                    </li>

                                </ul> */}

                                <h4 className='pt-1 pb-2 text-white'>Sridevi Women's Engineering College</h4>

                                <p>
                                    <i className="fa fa-map-marker-alt"></i>&nbsp; Wipro V.N.Pally, Gachibowli, Hyderabad West IT  Corridor, R.R.District-500075.
                                </p>

                                <p>
                                    <i className="fa fa-envelope"></i>
                                    <a className="mailLink" href="mailto:admin@swec.ac.in">&nbsp; admin@swec.ac.in </a>
                                </p>
                                <ul className="d-flex p-0">
                                    <p>
                                        <strong>For Admissions call :</strong> &nbsp;
                                    </p>
                                    <p>+91 - 99594 25729</p>
                                </ul>


                                <div className='col-5'>
                                    <ul className="socialMediaIcons d-flex p-0">
                                        <li>
                                            <a href="https://www.facebook.com/sweccollege/" target="_blank">
                                                <i className="fa-brands fa-facebook"></i>
                                            </a>
                                        </li>
                                        <li className='mx-2'>
                                            <a href="https://www.instagram.com/swecofficial" target="_blank">
                                                <i className="fa-brands fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.Linkedin.com/company/srideviengg/" target="_blank">
                                                <i className="fa-brands fa-linkedin"></i>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </section >
            </footer >
            <div className="copyright-area">
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-lg-6 col-md-4">
                                <div className="social-content ">
                                    <p className='text-black'>Copyright © 2001-2026 SWEC. All Rights Reserved.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-8">
                                <div className="copy">
                                    <p className='text-black'>
                                        Design &amp; Developed by
                                        <a href="http://zoninnovative.com/" target="_blank" className='text-black px-1'> <img
                                            className="img-fluid" src={zonLogo} width="15" style={{ verticalalign: "sub" }} alt="Zon logo"
                                        /> Zon Innovative</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Footer
